import { render, staticRenderFns } from "./bannerManager.vue?vue&type=template&id=f6419484"
import script from "./bannerManager.vue?vue&type=script&lang=js"
export * from "./bannerManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports